import { render, staticRenderFns } from "./AcceptOrRejectPresetAction.vue?vue&type=template&id=b98bb910&scoped=true&"
import script from "./AcceptOrRejectPresetAction.vue?vue&type=script&lang=js&"
export * from "./AcceptOrRejectPresetAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b98bb910",
  null
  
)

export default component.exports